import { useQuery } from "@tanstack/react-query";
import { getEditionCategoryList } from "src/api/editionCategory";
import { CATEGORY_STALE_TIME, QUERY_KEYS } from "../constants";
/**
 * 에디션 카테고리 데이터를 조회하는 훅
 * @param editionId - 에디션 ID
 */ export const useEditionCategory = (editionId)=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.EDITION_CATEGORY,
            editionId
        ],
        queryFn: ()=>getEditionCategoryList({
                editionId: editionId
            }),
        enabled: !!editionId && typeof editionId === "string",
        staleTime: CATEGORY_STALE_TIME
    });
};
